import * as Yup from "yup";
import {
  FIELD_NUMBER,
  FIELD_REQUIRED,
  FIELD_STRING,
} from "../../../common/constants/validationErrors";

export const exemplePostValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string().min(8).required("Required"),
  gender: Yup.mixed().required("Required"),
  terms: Yup.boolean().oneOf([true], "Must accept terms"),
  birthDate: Yup.date().required("Required"),
  avatar: Yup.mixed().required("File is required"),
});
